module.exports = __webpack_public_path__ + "img/produkt-mrkev.75cae77c.jpg";